export default __webpack_public_path__ + "static/hero-l4-image-6926b926c616e3e66efcc22fe654f367.png";